import { useCallback, useEffect, useState } from 'react';
import { fetchProfile } from '../models/mailApi';

export function useMailProfile(enabled, userId, live, loadDraft) {
  const [profile, setProfile] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(enabled);
  const initialize = useCallback(async () => {
    if (!enabled) return;
    setLoading(true); setError(null);
    try {
      const data = await fetchProfile();
      if (!live.current) return;
      setProfile(data);
      loadDraft(userId, data.primary_email);
    } catch (failure) { if (live.current) setError(failure); }
    finally { if (live.current) setLoading(false); }
  }, [enabled, userId, live, loadDraft]);
  useEffect(() => { if (enabled && !profile) initialize(); }, [initialize, enabled, profile]);
  return { profile, error, loading, initialize };
}
